import { BrowserRouter as Router, useRoutes } from "react-router-dom";

import Main from "./main";
import Test from "./pages/test";

import ForgotPage from "./pages/auth/forgot";
import LoginPage from "./pages/auth/login";
import RegisterPage from "./pages/auth/register";
import VerifySuccess from "./pages/auth/verify_success";

import IGVPage from "./pages/igv";
import IGVSearchPage from "./pages/igv/search";
import Gene from "./pages/gene";
import Variant from "./pages/variant";

import TermsPage from "./pages/privacy/terms";
import PrivacyPage from "./pages/privacy/privacy";

import N1Records from "./pages/records/n1";
import N2Records from "./pages/records/n2";
import N3Records from "./pages/records/n3";
import N4Records from "./pages/records/n4";
import N5Records from "./pages/records/n5";
import N6Records from "./pages/records/n6";
import N7Records from "./pages/records/n7";

import SearchN1Records from "./pages/records/n1tb";
import SearchN2Records from "./pages/records/n2tb";
import SearchN3Records from "./pages/records/n3tb";
import SearchN4Records from "./pages/records/n4tb";
import SearchN5Records from "./pages/records/n5tb";
import SearchN6Records from "./pages/records/n6tb";
import SearchN7Records from "./pages/records/n7tb";

import Layout from "./components/layouts";

import BackendLayout from "./layouts/BackendLayout";
import BackendIndexPage from "./pages/backend";
import BackendUserPage from "./pages/backend/user";
import BackendCategoyPage from "./pages/backend/category";
import BackendToolPage from "./pages/backend/tools";

import BackendN1Page from "./pages/backend/n1";
import BackendN2Page from "./pages/backend/n2";
import BackendN3Page from "./pages/backend/n3";
import BackendN4Page from "./pages/backend/n4";
import BackendN5Page from "./pages/backend/n5";
import BackendN6Page from "./pages/backend/n6";
import BackendN7Page from "./pages/backend/n7";

import BackendN1ImportPage from "./pages/backend/n1.import";
import BackendN2ImportPage from "./pages/backend/n2.import";
import BackendN3ImportPage from "./pages/backend/n3.import";
import BackendN4ImportPage from "./pages/backend/n4.import";
import BackendN5ImportPage from "./pages/backend/n5.import";
import BackendN6ImportPage from "./pages/backend/n6.import";
import BackendN7ImportPage from "./pages/backend/n7.import";
import GnomeBrowserPage from "./pages/gnome";
import SearchLayout from "./layouts/SearchLayout";
import ToolPage from "./pages/tools";

const App = () => {
    const routes = useRoutes([
        {
            path: "",
            element: <Layout />,
            children: [
                { path: "", element: <Main /> },
                // { path: "n1", element: <N1Records /> },
                // { path: "n1/:name", element: <SearchN1Records /> },
                // { path: "n2", element: <N2Records /> },
                // { path: "n2/:name", element: <SearchN2Records /> },
                // { path: "n3", element: <N3Records /> },
                // { path: "n3/:name", element: <SearchN3Records /> },
                // { path: "n4", element: <N4Records /> },
                // { path: "n4/:name", element: <SearchN4Records /> },
                // { path: "n5", element: <N5Records /> },
                // { path: "n5/:name", element: <SearchN5Records /> },
                // { path: "n6", element: <N6Records /> },
                // { path: "n6/:name", element: <SearchN6Records /> },
                // { path: "n7", element: <N7Records /> },
                // { path: "N7/:name", element: <SearchN7Records /> },

                // { path: "igv", element: <IGVSearchPage /> },
                // { path: "igv/:name", element: <IGVPage /> },

                { path: "login", element: <LoginPage /> },
                { path: "forgot", element: <ForgotPage /> },
                { path: "reset/:token", element: <ForgotPage /> },
                { path: "register", element: <RegisterPage /> },
                { path: "privacy", element: <PrivacyPage /> },
                { path: "terms", element: <TermsPage /> },
                { path: "email/verify/already-success", element: <VerifySuccess /> },

                // { path: "gene/:name", element: <Gene /> },
                // { path: "variant/:name", element: <Variant /> },
                
                { path: "tools", element: <ToolPage /> },
                { path: "gnome-browser", element: <GnomeBrowserPage /> },
            ],
        },
        {
            path: "search",
            element: <SearchLayout />,
            children: [
                { path: "", element: <IGVSearchPage /> },
                { path: "igv/:name", element: <IGVPage /> },
                { path: "n1", element: <N1Records /> },
                { path: "n1/:name", element: <SearchN1Records /> },
                { path: "n2", element: <N2Records /> },
                { path: "n2/:name", element: <SearchN2Records /> },
                { path: "n3", element: <N3Records /> },
                { path: "n3/:name", element: <SearchN3Records /> },
                { path: "n4", element: <N4Records /> },
                { path: "n4/:name", element: <SearchN4Records /> },
                { path: "n5", element: <N5Records /> },
                { path: "n5/:name", element: <SearchN5Records /> },
                { path: "n6", element: <N6Records /> },
                { path: "n6/:name", element: <SearchN6Records /> },
                { path: "n7", element: <N7Records /> },
                { path: "N7/:name", element: <SearchN7Records /> },
            ],
        },
        {
            path: "backend",
            element: <BackendLayout />,
            children: [
                { path: "", element: <BackendIndexPage /> },
                { path: "n1", element: <BackendN1Page /> },
                { path: "n1/import", element: <BackendN1ImportPage /> },
                { path: "n2", element: <BackendN2Page /> },
                { path: "n2/import", element: <BackendN2ImportPage /> },
                { path: "n3", element: <BackendN3Page /> },
                { path: "n3/import", element: <BackendN3ImportPage /> },
                { path: "n4", element: <BackendN4Page /> },
                { path: "n4/import", element: <BackendN4ImportPage /> },
                { path: "n5", element: <BackendN5Page /> },
                { path: "n5/import", element: <BackendN5ImportPage /> },
                { path: "n6", element: <BackendN6Page /> },
                { path: "n6/import", element: <BackendN6ImportPage /> },
                { path: "n7", element: <BackendN7Page /> },
                { path: "n7/import", element: <BackendN7ImportPage /> },
                { path: "user", element: <BackendUserPage /> },
                { path: "category", element: <BackendCategoyPage /> },
                { path: "tools", element: <BackendToolPage /> },
            ],
        },
    ]);

    return routes;
};

const AppWrapper = () => {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <App />
        </Router>
    );
};

export default AppWrapper;
